/* @jsx h */
import { $$ } from '../../../../shared/js/utils/dom';
import { labels } from '../config';
import { Fragment } from 'preact';
import FilterAccordion from './FilterAccordion';

const FilterContainer = ({ facets, triggerAjaxSubmit }) => {
  function handleReset() {
    // find related checkbox and uncheck it before submit the form
    const checkboxes = $$('.search input[type="checkbox"]');
    checkboxes.forEach(checkbox => (checkbox.checked = false));
    triggerAjaxSubmit();
  }

  return (
    <Fragment>
      <div class="search-filter">
        <section class="main-section main-section--with-background main-section--no-margins">
          <div class="main-section__horizontal-spacer">
            <div class="main-section__inner">
              <header class="main-section__header">
                <h2 class="main-section__heading">
                  {labels.faceting.narrowSearch}
                </h2>
              </header>
              <div class="main-section__content">
                <div class="search-filter__row">
                  {facets.main &&
                    facets.main.map(facet => {
                      return (
                        <FilterAccordion
                          key={facet.label}
                          title={facet.label}
                          options={facet.options}
                          filterName={facet.name}
                          mode={facet.mode}
                          triggerAjaxSubmit={triggerAjaxSubmit}
                        />
                      );
                    })}
                </div>
              </div>
              <footer class="search-filter__footer">
                <button
                  className="search-filter__reset"
                  onClick={handleReset}
                  type="button"
                >
                  {labels.faceting.removeAllFilters}
                  <span class="icon icon--cross">
                    <svg
                      class="icon__svg"
                      focusable="false"
                      role="img"
                      aria-hidden="true"
                    >
                      <use href="#icon-cross" />
                    </svg>
                  </span>
                </button>
              </footer>
            </div>
          </div>
        </section>
      </div>
    </Fragment>
  );
};

export default FilterContainer;
